<script>
export default {
    
}
</script>
<template>
    <div id="submit" class="submit" @click="$emit('click', $event)">免费预约咨询</div>
</template>

<style lang="stylus" scoped>
.submit
    margin 1.17rem 0 0
    height 2.34rem
    line-height 2.34rem
    text-align center
    font-size 0.853rem
    border-radius: 1.17rem
    background linear-gradient(135deg ,rgba(255,168,0,1) 0%, rgba(255,60,0,1) 100%)
    background-color #FF3C00
    color #fff
    cursor pointer
</style>